import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface RenewalDetectionResult {
  isRenewal: boolean;
  previousTransaction: any | null;
  renewalCount: number;
  lastTransactionDate: string | null;
}

export function useRenewalDetection(
  customerId: string | null,
  planId: string | null,
  enabled: boolean = true,
  excludeTransactionId?: string | null
) {
  return useQuery<RenewalDetectionResult>({
    queryKey: ['renewal-detection', customerId, planId, excludeTransactionId],
    queryFn: async () => {
      if (!customerId || !planId) {
        return {
          isRenewal: false,
          previousTransaction: null,
          renewalCount: 0,
          lastTransactionDate: null,
        };
      }

      // Buscar transações anteriores pagas do mesmo cliente e plano
      let query = supabase
        .from('transactions')
        .select('*')
        .eq('customer_saas_id', customerId)
        .eq('product_plan_id', planId)
        .eq('payment_status', 'paid')
        .order('payment_date', { ascending: false });

      // Excluir transação atual se estiver editando
      if (excludeTransactionId) {
        query = query.neq('id', excludeTransactionId);
      }

      const { data: previousTxs, error } = await query;

      if (error) throw error;

      const isRenewal = (previousTxs?.length || 0) > 0;
      const previousTransaction = previousTxs?.[0] || null;
      const renewalCount = previousTxs?.length || 0;
      const lastTransactionDate = previousTransaction?.payment_date || null;

      return {
        isRenewal,
        previousTransaction,
        renewalCount,
        lastTransactionDate,
      };
    },
    enabled: enabled && !!customerId && !!planId,
  });
}
